import { useTranslation } from 'react-i18next';
import { UserRoles } from '@anytag/graphql';
import { Option } from '@anytag/shared-types';
import { useAllTalentAgencyOrPartnerOptions } from '@anytag/shared-hooks';
import { MultipleSelectorFieldProps, SelectorField } from '@anytag/shared-molecules';
import { InfluencerFormKeys } from '../InfluencerForm';
import { InfluencerSharedKeys } from './types';

export const TalentAgencyPartnerField = (
  props: Omit<MultipleSelectorFieldProps<InfluencerFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const { allTalentAgenciesPartners } = useAllTalentAgencyOrPartnerOptions();

  const options: Option[] = allTalentAgenciesPartners.map(({ name, id, role }) => ({
    value: String(id),
    label: `${name}  (${t(role === UserRoles.TALENT_AGENCY ? 'talent' : 'partner')})`
  }));

  return (
    <SelectorField<InfluencerFormKeys>
      options={options}
      title={t('Selector.Partner/Talent Agency')}
      name={InfluencerSharedKeys.talentAgencyOrPartnerIds}
      multiple
      {...props}
    />
  );
};
